// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combo-box__icon_3df5e853 {
  font-size: 1.584rem;
}
.combo-box__item_default_3df5e853 {
  color: #657682;
  font-style: italic;
}
.combo-box__meta-data_3df5e853 {
  text-transform: capitalize;
  color: #84919b;
  font-weight: 600;
  white-space: nowrap;
}
.combo-box_input_3df5e853 {
  text-overflow: ellipsis;
  cursor: pointer;
}
.item__check_3df5e853 {
  margin-left: 1.334rem;
  visibility: hidden;
}
.item__check_3df5e853.selected_3df5e853 {
  visibility: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"combo-box__icon": `combo-box__icon_3df5e853`,
	"combo-box__item_default": `combo-box__item_default_3df5e853`,
	"combo-box__meta-data": `combo-box__meta-data_3df5e853`,
	"combo-box_input": `combo-box_input_3df5e853`,
	"item__check": `item__check_3df5e853`,
	"selected": `selected_3df5e853`
};
export default ___CSS_LOADER_EXPORT___;
